import { ChangeEvent, MouseEvent } from "react";
import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import { AXNUITextInput } from "@iddataweb/idw-common-ui/containers";
import styles from "./autocomplete-subpremise-input.less";

type AutocompleteSubpremiseInputProps = {
    subpremise: string;
    setSubpremise: (subpremise: string) => void;
    setIsEditingSubpremise: (isEditing: boolean) => void;
};

export const AutocompleteSubpremiseInput = (props: AutocompleteSubpremiseInputProps) => {
    const { subpremise, setSubpremise, setIsEditingSubpremise } = props;

    const content = useSelector(getLanguageContent);

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value) {
            setSubpremise(value);
        } else {
            setSubpremise("");
        }
    };

    const onClickCancel = (event: MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        setSubpremise("");
        setIsEditingSubpremise(false);
    };

    return (
        <div className={styles.autocompleteSubpremiseInput}>
            <div className={styles.autocompleteSubpremiseHeader}>
                <label>{content.form.internationalAddress.addSubPremise}</label>
                <a id={"cancel-subpremise-link"} href="" onClick={onClickCancel}>
                    {content.common.button.cancel}
                </a>
            </div>
            <AXNUITextInput
                required={false}
                controlId={"address-subpremise"}
                automationId={"address-subpremise"}
                disabled={false}
                title={content.form.internationalAddress.addSubPremise}
                onBlur={() => { }}
                onChange={onChange}
                value={subpremise}
            />
        </div>
    );
};